import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { SectionHead } from './SectionHead';
import { MockChart } from './MockChart';

const Row = ({ a, b, dir }) => (
  <div className="mk-wrow">
    <span>{a}</span>
    <span className={`mk-dir ${dir}`}>{dir === 'up' ? <ArrowUpRight size={13} aria-hidden="true" /> : <ArrowDownRight size={13} aria-hidden="true" />}{b}</span>
  </div>
);

const PANELS = [
  { title: 'AI Search', desc: 'Chart with EMA overlays and AI entry, target and stop lines next to the full outlook.', visual: <MockChart bars={36} /> },
  { title: 'Options flow board', desc: 'Large trades with contract, premium and side. Filter by ticker, size or expiry.',
    visual: <><Row a="EXMPL 115C · 2 wks · Sweep" b="Calls" dir="up" /><Row a="DEMO 40P · 1 mo · Block" b="Puts" dir="down" /><Row a="EXMPL 120C · 1 mo · Sweep" b="Calls" dir="up" /></> },
  { title: 'Daily Market Snapshot', desc: 'Index ETFs, yields, macro calendar, headlines and earnings to watch, with a 60-second AI briefing.',
    visual: <><Row a="S&P 500 (SPY stand-in)" b="Index ETF" dir="up" /><Row a="10Y Treasury yield" b="Rates" dir="down" /><Row a="CPI release · 8:30 AM ET" b="Macro" dir="up" /></> },
  { title: 'Track record', desc: 'Past outlooks graded against what price did by the end of their timeframe, by strategy.',
    visual: <div className="mk-wbars" aria-hidden="true">{[62, 48, 55, 40].map((h, i) => <i key={i} style={{ height: `${h}%` }} />)}</div> },
];

export const InsideWorkspace = () => (
  <section className="mk-section mk-alt" id="workspace" aria-labelledby="workspace-title">
    <div className="mk-container">
      <SectionHead id="workspace-title" eyebrow="Inside the workspace" title="The tools you work with every day" sub="Illustrative layouts with fictional tickers. In the app, every value comes from market data with an as-of time." />
      <ul className="mk-ws-grid">
        {PANELS.map((p) => (
          <li key={p.title} className="mk-card mk-ws" data-testid="workspace-panel">
            <div className="mk-ws-visual" aria-hidden="true">{p.visual}</div>
            <h3>{p.title}</h3>
            <p>{p.desc}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
